import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Div, Typography } from '@icecreamsocial/components';

import {
	BusinessPaymentProcessorForm,
	Pagename,
} from '../../../../presentational';
import { useStore } from '../../../../../utils/hooks';
import { OptimisticPaymentProcessor } from '../../../../optimistic';
import { useProcessor } from '../../../../../utils/hooks/useProcessor';
import { useBusiness } from '../../../../providers/Business';

const PaymentProcessorSettings = () => {
	return (
		<Div>
			<Pagename>Reward Processing</Pagename>
			<BusinessPaymentProcessorForm />
		</Div>
	);
};

PaymentProcessorSettings.displayName = 'Settings.Business.PaymentProcessor';
export default observer(PaymentProcessorSettings);
